import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=64ba37c3&"
import script from "./LeftMenu.vue?vue&type=script&lang=js&"
export * from "./LeftMenu.vue?vue&type=script&lang=js&"
import style0 from "./LeftMenu.vue?vue&type=style&index=0&id=64ba37c3&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports